import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-article-line"></i>
            SEO Guides & Articles
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
            In-Depth Sugargoo Spreadsheet Guides
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            Explore our collection of comprehensive guides covering every aspect of the Sugargoo shopping experience — from beginner tutorials to advanced shipping strategies.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/` + article.slug}
              className="group block bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-accent-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-background-50/85 backdrop-blur-sm text-xs font-medium text-foreground-800">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1.5 mt-4 text-primary-500 text-sm font-medium">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}